import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = styled.button`
    align-items: center;
    background: rgb(245, 245, 245, 0.32);
    border: none;
    border-radius: 0px;
    cursor: pointer;
    display: flex;
    height: 32px;
    justify-content: center;
    width: 32px;

    &.active {
        background: rgb(216, 216, 216, 0.32);
        cursor: default;
    }
`;

const ViewToggleButton = ({ Icon, active = false, onClick }) => {
    const [hover, setHover] = useState(false);

    return (
        <Button
            type="button"
            className={classnames({ active })}
            onClick={onClick}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <Icon active={active || hover} />
        </Button>
    );
};

ViewToggleButton.propTypes = {
    Icon: PropTypes.elementType.isRequired,
    active: PropTypes.bool,
    onClick: PropTypes.func,
};

export default ViewToggleButton;
